export const enum EaseType {
	In = 0,
	Out = 1,
	InOut = 2,
	OutIn = 3
}

export const enum EaseCurve {
	Linear = 0,
	Quad = 1,
	Cubic = 2,
	Quart = 3,
	Quint = 4,
	Expo = 5,
	Circ = 6,
	Sine = 7,
	Bounce = 8,
	Back = 9,
	Elastic = 10,
}

export function easing(value: number, type: EaseType, curve: EaseCurve, strength: number = 1): number {
	if (value == 0 || value == 1) {
		return value
	}

	switch (type) {
		default:
		case EaseType.In:
			return calc(value, curve, strength)

		case EaseType.Out:
			return 1 - calc(1 - value, curve, strength)

		case EaseType.InOut:
			if (value <= 0.5) {
				return calc(value * 2, curve, strength) * 0.5
			}
			else {
				return 1 - calc((1 - value) * 2, curve, strength) * 0.5
			}

		case EaseType.OutIn:
			return value
	}
}

function calc(value: number, curve: EaseCurve, strength: number) {
	switch (curve) {
		case EaseCurve.Quad:
			return Math.pow(value, 2)

		case EaseCurve.Cubic:
			return Math.pow(value, 3)

		case EaseCurve.Quart:
			return Math.pow(value, 4)

		case EaseCurve.Quint:
			return Math.pow(value, 5)

		case EaseCurve.Expo:
			return Math.pow(2, 8 * (value - 1))

		case EaseCurve.Circ:
			return 1 - Math.sin(Math.acos(value))

		case EaseCurve.Sine:
			return 1 - Math.sin((1 - value) * Math.PI / 2)

		case EaseCurve.Bounce: {
			let a: number, b: number, give = 0

			for (a = 0, b = 1; true; a += b, b/= 2){
				if (value >= (7 - 4 * a) / 11) {
					give = b * b - Math.pow((11 - 6 * a - 11 * value) / 4, 2)
					break
				}
			}

			return give
		}

		case EaseCurve.Back:
			return Math.pow(value, 2) * ( (strength + 1) * value - strength)

		case EaseCurve.Elastic:
			return Math.pow(2, 10 * --value ) * Math.cos(20 * value * Math.PI * strength / 3)

		default:
			return value
	}
}